import { request } from 'api/request';

export const cancelDowngrade = async () => {
  const response = await request.post('v1/plans/cancel-downgrade/');
  return response.data;
};
